import { render, staticRenderFns } from "./versionPanel.vue?vue&type=template&id=2e85d0b4&"
import script from "./versionPanel.vue?vue&type=script&lang=js&"
export * from "./versionPanel.vue?vue&type=script&lang=js&"
import style0 from "./versionPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports